// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/status-change';

export const resetStatusChangeRequestState = () => ({
    data: getDefaultState(),
    type: actions.RESET_STATUS_CHANGE_REQUEST_STATE
});



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/reset-status-change-request-state.js